import { put, takeEvery } from "redux-saga/effects";
import { ADD_DELIVERY_ADDRESS, DELETE_DELIVERY_ADDRESS, LIST_DELIVERY_ADDRESS, VIEW_DELIVERY_ADDRESS } from "../SagaAction/actions";
import { addAddressFailure, addAddressRequest, addAddressSuccess, deleteAddressFailure, deleteAddressRequest, deleteAddressSuccess, listAddressFailure, listAddressRequest, listAddressSuccess, viewAddressFailure, viewAddressRequest, viewAddressSuccess } from "../Slices/DeliveryAddressSlice";
import requestApi from "../../utils/request";

function* addAddress (params){
    try {
        yield put(addAddressRequest())
        const {data} = yield requestApi.post("/add-edit-address",params.payload)
        yield put(addAddressSuccess(data))
        if(typeof params.callback === "function"){
            yield params.callback()
        }
    } catch (error) {
        yield put (addAddressFailure(error))
    }
}

function* deleteAddress (params){
    try {
        yield put(deleteAddressRequest())
        const {data} = yield requestApi.post("/delete-address",params.payload)
        yield put(deleteAddressSuccess())
        if(typeof params.callback === "function"){
            yield params.callback()
        }
    } catch (error) {
        yield put (deleteAddressFailure(error))
    }
}

function* listAddress (){
    try {
        yield put(listAddressRequest())
        const {data} = yield requestApi.post("/list-address")
        yield put(listAddressSuccess(data))
    } catch (error) {
        yield put (listAddressFailure(error))
    }
}

function* viewAddress (params){
    try {
        yield put(viewAddressRequest())
        const {data} = yield requestApi.post("/view-address",params.payload)
        yield put(viewAddressSuccess(data))
        if(typeof params.callback === "function"){
            yield params.callback()
        }
    } catch (error) {
        yield put (viewAddressFailure(error))
    }
}

function* DeliveryAddressSaga(){
    yield takeEvery(ADD_DELIVERY_ADDRESS,addAddress)
    yield takeEvery(DELETE_DELIVERY_ADDRESS,deleteAddress)
    yield takeEvery(LIST_DELIVERY_ADDRESS,listAddress)
    yield takeEvery(VIEW_DELIVERY_ADDRESS,viewAddress)
}

export default DeliveryAddressSaga;